import { FeatureDTO } from "./FeatureDTO";

export class RedirectMyCoursesLoginDTO extends FeatureDTO {
    constructor(sub?) {
        super(sub);
    }
}
